import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

import config from '../../../config';
import * as utils from '../../../util/utils';
import { colors } from '../../../theme/tokens';

/* Files already stored for a bug. With onDeleteImage/onDeleteVideo (edit bug) each tile gets a delete
   button; the callbacks keep the (event, { 'data-index' }) shape EditBug expects. */
export const BugAttachments = (props) => {
  const editable = props.onDeleteImage && props.onDeleteVideo;
  const images: string[] = props.imageFilePaths || [];
  const videos: string[] = props.videoFilePaths || [];

  if (!images.length && !videos.length) {
    return null;
  }

  const tile = (key: string, name: string, href: string | null, preview: React.ReactNode, onDelete?: (event: any) => void) => {
    const box = (
      <Box sx={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f7fb', '& img, & video': { maxWidth: '100%', maxHeight: '100%' } }}>
        {preview}
      </Box>
    );
    return (
      <Box key={key} sx={{ width: 160, border: `1px solid ${colors.dividerBlue}`, borderRadius: 2, overflow: 'hidden', backgroundColor: '#fff' }}>
        {href ? (
          <Link href={href} target="_blank" rel="noopener noreferrer" underline="none">
            {box}
          </Link>
        ) : (
          box
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, minHeight: 34 }}>
          <Typography noWrap title={name} sx={{ flex: 1, fontSize: 12, color: colors.textGrey }}>{name}</Typography>
          {onDelete && (
            <IconButton size="small" aria-label={`Delete ${name}`} onClick={onDelete}>
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
      {images.map((imageFilePath, i) => {
        const href = new URL(imageFilePath, config.apiEndpoint).href;
        const filename = imageFilePath.split('/').pop() || '';
        const preview = utils.isImage(filename) ? (
          <img src={href} alt="Bug attachment" />
        ) : (
          <Box sx={{ textAlign: 'center', color: colors.textGrey }}>
            <InsertDriveFileOutlinedIcon />
            <Typography sx={{ fontSize: 11 }}>{utils.getFileExtension(filename)}</Typography>
          </Box>
        );
        return tile(`image-${i}`, filename, href, preview, editable ? (event) => props.onDeleteImage(event, { 'data-index': i }) : undefined);
      })}
      {videos.map((videoFilePath, i) => {
        const href = new URL(videoFilePath, config.apiEndpoint).href;
        const preview = (
          <video controls preload="none">
            <source src={href} type="video/mp4" />
          </video>
        );
        return tile(`video-${i}`, `Video #${i + 1}`, null, preview, editable ? (event) => props.onDeleteVideo(event, { 'data-index': i }) : undefined);
      })}
    </Box>
  );
};
